import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {UserSetting} from '../../models/user-setting';
import {Subscription} from 'rxjs/Rx';
import {DialogService} from '../../services/dialog.service';
import {NotifierService} from 'angular-notifier';
import {SharedValueService} from '../../services/shared-value.service';
import {Helper} from '../../common/helper';
import {EventService} from '../../services/event.service';
import * as moment from 'moment';
import {EVENT_STATUS} from '../../common/constants';
import {RoomSetting} from '../../models/room-setting';
import {RoomService} from '../../services/room.service';
import 'bootstrap-datepicker';
import {isNullOrUndefined} from 'util';
import {HistorySetting} from '../../models/history-setting';
import {Angular2Csv} from 'angular2-csv';
declare const $: any;

class SearchCondition {
  public date: string;
  public name: string;
  public roomIds: any;
  public status: any;

  constructor(date?: string, name?: string, roomIds?: any, status?: any) {
    this.date = date || moment().format('MM-YYYY');
    this.name = name || '';
    this.roomIds = roomIds || [];
    this.status = status || [EVENT_STATUS.CHECK_IN, EVENT_STATUS.CANCEL, EVENT_STATUS.NEW];
  }
}
@Component({
  selector: 'app-history-booking-page',
  templateUrl: './history-booking-page.component.html',
  styleUrls: ['./history-booking-page.component.scss'],
  preserveWhitespaces: false
})
export class HistoryBookingPageComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(DatatableComponent) userTable: DatatableComponent;
  displayedHistory: HistorySetting[] = [];
  isLoading = false;
  searchCondition: SearchCondition = new SearchCondition(moment().format('MM-YYYY'));
  lengthMenu = [
    {value: 20, text: '20'},
    {value: 50, text: '50'},
    {value: 100, text: '100'},
    {value: -1, text: 'All'},
  ];
  pageSize = 20;
  historySubscription: Subscription;
  userSession: UserSetting;
  rooms: RoomSetting[] = [];
  roomSubscription: Subscription;
  selectedRoomId = -1;
  currentMonth: string;
  eventStatus: typeof EVENT_STATUS = EVENT_STATUS;
  statusArr = [
    {value: EVENT_STATUS.NEW, text: 'New'},
    {value: EVENT_STATUS.CHECK_IN, text: 'Checked in'},
    {value: EVENT_STATUS.CANCEL, text: 'Cancel'}
  ];

  constructor(private eventService: EventService,
              private dialog: DialogService,
              private notify: NotifierService,
              private shared: SharedValueService,
              private helper: Helper,
              private roomService: RoomService,
              private dialogService: DialogService) {}

  ngOnInit() {
    setTimeout(() => {
      this.isLoading = true;
    });
    this.userSession = this.shared.getUserSession();
    this.currentMonth = moment().format('MM-YYYY');
    this.searchCondition.date = this.currentMonth;
    // get all rooms
    this.roomSubscription = this.roomService.getAllRooms().subscribe(list => {
      if (list.length) {
        this.rooms = list;
        this.searchCondition.roomIds =  this.rooms.map(item => {
          return item.id;
        });
      }
    });
    this.historySubscription = this.eventService.getBookingHistory(this.searchCondition).subscribe(list => {
      this.displayedHistory = list.data;
      setTimeout(() => {
        this.isLoading = false;
      });
    }, error => {
      setTimeout(() => {
        this.isLoading = false;
      });
      this.notify.notify('error', 'Error occurred!');
    });
  }

  ngAfterViewInit() {
    $('#selectDate').datepicker({
      format: 'mm-yyyy',
      viewMode: 'months',
      minViewMode: 'months',
      autoClose: true,
      clearBtn: true,
      endDate: moment().format('MM-YYYY'),
      templates: {
        leftArrow: '<i class="fa fa-chevron-left"></i>',
        rightArrow: '<i class="fa fa-chevron-right"></i>',
      },
    });
    $( '#selectDate').datepicker( 'setDate', this.currentMonth);
  }

  getRowClass(row) {
    return {
      'bg-danger-1': row.status === EVENT_STATUS.CANCEL
    };
  }

  ngOnDestroy() {
    this.helper._unsubsribe(this.historySubscription);
  }

  downloadCSV() {
    this.dialogService.setLoaderVisible(true);
    this.helper._unsubsribe(this.historySubscription);
    this.historySubscription = this.eventService.getBookingHistory(this.searchCondition).subscribe((list) => {
      const dataCSV = [];
      list.data.forEach((item, index) => {
        const element = {
          '' : index + 1,
          'summary': item.summary,
          'r_name': item.r_name,
          'username': item.username,
          'email': item.email,
          'start': item.start,
          'end': item.end,
          'status': item.status
        };
        dataCSV.push(element);
      });
      dataCSV.unshift(['', 'Summary', 'Room name', 'Booked by', 'Email', 'Start', 'End', 'Event status']);
      const month = moment(this.searchCondition.date, 'MM-YYYY').format('MMM-YYYY');
      new Angular2Csv(dataCSV, `Omi-booking-history-${month}`);
      this.dialogService.setLoaderVisible(false);
    }, err => {
      this.dialogService.setLoaderVisible(false);
      this.notify.notify('error', 'Error occurred!');
    });
  }

  searchEvent() {
    this.helper._unsubsribe(this.historySubscription);
    this.searchCondition.date = $('#selectDate').val();
    setTimeout(() => {
      this.isLoading = true;
    });
    this.historySubscription = this.eventService.getBookingHistory(this.searchCondition).subscribe(list => {
      this.displayedHistory = list.data;
      setTimeout(() => {
        this.isLoading = false;
      });
    }, error => {
      this.notify.notify('error', 'Error occurred!');
      setTimeout(() => {
        this.isLoading = false;
      });
    });
  }

  showItems(length) {
    const selectedPageSize = parseInt(length, 10);
    if (selectedPageSize !== -1) {
      this.pageSize = selectedPageSize;
    } else {
      this.pageSize = this.displayedHistory.length;
    }
  }

  onChangeRoom(event) {
    if (!isNullOrUndefined(event) && event > -1) {
      this.searchCondition.roomIds = [event];
    } else {
      if (this.rooms.length) {
        this.searchCondition.roomIds =  this.rooms.map(item => {
          return item.id;
        });
      }
    }
  }
  onChangeStatus(event) {
    const value = event.target.value;
    if (value) {
      this.searchCondition.status = [value];
    } else {
      this.searchCondition.status = Object.keys(this.eventStatus);
    }
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/history-booking-page/history-booking-page.component.ts